import { Component, inject } from '@angular/core'
import { NavigatorService } from '@core/services/navigator.service'
import { MatIconModule } from '@angular/material/icon'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
    selector: 'app-notifications-menu-content',
    styleUrls: ['./notifications-menu-content.component.sass'],
    templateUrl: './notifications-menu-content.component.html',
    imports: [TranslocoModule, MatIconModule],
})
export class NotificationsMenuContentComponent {
    private readonly navigatorService = inject(NavigatorService)

    navigateNotifications() {
        this.navigatorService.goToNotificationPage()
    }
}
